"use client";

import * as React from "react";
import Image from "next/image";
import {
  ClientMagicLinkForm,
  type ClientMagicLinkFormStep,
} from "@/components/client-magic-link-form";

export function ClientLoginPageContent() {
  const [step, setStep] = React.useState<ClientMagicLinkFormStep>("email");
  const isStaffAccountStep = step === "staffAccount";

  return (
    <div
      className={
        isStaffAccountStep
          ? "flex w-full max-w-2xl min-h-[calc(100dvh-4rem)] flex-col items-center justify-center px-2 sm:px-0"
          : "w-full max-w-md space-y-8"
      }
    >
      {!isStaffAccountStep ? (
        <div className="text-center">
          <Image
            className="mx-auto h-20 w-auto"
            src="https://www.thekautapengroup.com/wp-content/uploads/2021/06/cropped-cropped-Logo-TKG-Cbajada-01-150x150.png"
            alt="The Kautapen Group"
            width={150}
            height={80}
          />
          <h2 className="mt-6 text-3xl font-extrabold text-stone-900">
            Welcome back
          </h2>
          <p className="mt-2 text-sm text-stone-600">Guest / client sign-in</p>
        </div>
      ) : null}

      <ClientMagicLinkForm onStepChange={setStep} />
    </div>
  );
}
